






































import Vue from 'vue';
import Helpers from '@/utils/Helpers';

export default Vue.extend({
  name: 'HubTextarea' as string,

  inheritAttrs: false,

  props: {
    appendIcon: {
      type: String,
      default: null,
    },
    appendIconDisabled: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: '#F5F5F5',
    },
    color: {
      type: String,
      default: '#46467E',
    },
    copy: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    outline: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Number,
      default: 2,
    },
    value: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      copySuccess: false,
    };
  },

  computed: {
    backColor(): string {
      return `${this.disabled ? '#DCDCDC' : this.backgroundColor}`;
    },
    border(): string {
      return `2px solid ${this.outline ? this.color : 'transparent'}`;
    },
    handleAppendIcon() {
      return this.copy ? 'mdi-content-copy' : this.appendIcon;
    },
  },

  mounted() {
    const textarea: (HTMLTextAreaElement | null) = this.$el.querySelector('textarea');
    const vuetifyInput: (HTMLDivElement | null) = this.$el.querySelector('.v-input__slot');

    Object.assign(textarea?.style, { color: this.color });

    this.changeBorder(vuetifyInput);
  },

  methods: {
    changeBorder(vuetifyInput: (HTMLDivElement | null)): void {
      return vuetifyInput?.style.setProperty('border', this.border, 'important');
    },
    async handleClickAppend(event: Event) {
      if (this.copy) {
        await this.handleCopy();
      }

      this.$emit('clickAppend', event);
    },
    handleCopy() {
      Helpers
        .copyToClipboard(this.value)
        .then(() => this.$emit('copied', this.value))
        .then(() => {
          this.copySuccess = true;

          setTimeout(() => { this.copySuccess = false; }, 1500);
        })
        .catch(() => { /**/ });
    },
  },
});
